import { namespacedClassnames } from '../../common/namespace-classes';
import * as React from 'react';
export var ToggleButton = function (props) {
    var checkedClassName = props.isChecked ? 'checked' : '';
    var classNames = namespacedClassnames('toggle-button', checkedClassName);
    return React.createElement("button", { onClick: props.onClick, className: classNames, disabled: props.disabled }, props.children);
};
//# sourceMappingURL=toggle-button.js.map